import { FormHelpers } from "./helpers/form-helpers";

export class Newsletter {
	
	footerSignUp() {
		const footerForm = document.querySelector('footer .footer-signup');

		footerForm.addEventListener('submit',
			(e) => {
				e.preventDefault();
				FormHelpers.postAjax({
					url: footerForm.getAttribute('action'),
					data: { email: footerForm.querySelector('input').value },
					success: (response) => {
						

						if (response.success) {
							const success = document.querySelector('.footer-email-message') as HTMLElement;
							success.classList.toggle('d-none');
							footerForm.classList.toggle('d-none');
						}
					},
					error: (response) => {
						console.log(response);
					}
				});
			});
	}
}